import { z } from "zod";

export const zExtraSettings = z.object({
  sso: z.boolean().optional(),
  extRegUrl: z.string().optional(),
  techSupport: z.boolean().optional(),
  supportEmail: z.string().optional(),
});
export type ZExtraSettings = z.infer<typeof zExtraSettings>;
